import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact";
import { useProductFilters } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import RangeInput from "./elements/RangeInput";
import Icon from "./elements/Icon";

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];
    const [active, setActive] = useState(true);
    const { filters, removeAll } = useProductFilters();

    const [currencySymbol, setCurrencySymbol] = useState("");

    useEffect(() => {
        const pathname = window.location.pathname;

        if (pathname.includes("/fr-fr/")) {
            setCurrencySymbol("€");
        } else if (pathname.includes("/de-de/")) {
            setCurrencySymbol("€");
        } else if (pathname.includes("/en-us/")) {
            setCurrencySymbol("$")
        } else if (pathname.includes("/en-eu/")) {
            setCurrencySymbol("€")
        } else if (pathname.includes("/en-row/")) {
            setCurrencySymbol("$")
        } else {
            setCurrencySymbol("£");
        }
    }, []);

    return (
        <li class={`ns-sidebar-dropdown ns-range-facet-dropdown-container ${active ? "ns-active" : ""}`}>
            <a
                class="ns-facet-link"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!active);
                }}
            >
                <span class="ns-facet-name">
                    <svg class="ns-facet-name-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="m7 14l5-5l5 5z" /></svg>
                    {facet.name} {currencySymbol}
                </span>
                {isSelected && (
                    <a
                        href="javascript:void(0)"
                        class="ns-clear-facet-text"
                        onClick={(e) => {
                            e.stopPropagation();
                            removeAll();
                        }}
                    >
                        Clear
                    </a>
                )}
            </a>
            <div class="ns-sidebar-submenu">
                <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-input-container flex-shrink-1">
                        <div class="ns-input-currency">{currencySymbol}</div>
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined;
                                updateRange([value, range[1]]);
                            }}
                        />
                    </div>
                    <div class="ns-input-separator"> - </div>
                    <div class="ns-input-container flex-shrink-1">
                        <div class="ns-input-currency">{currencySymbol}</div>
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined;
                                updateRange([range[0], value]);
                            }}
                        />
                    </div>
                </div>
                <div class="ns-slider-wrapper">
                    <RangeSlider id={facet.id} />
                    <div class="ns-slider-segments">
                        <div class="ns-indicator" style="left: 0%; bottom: -25px; position: absolute; transform: translateX(-50%)">{Math.round(min)}</div>
                        <div class="ns-indicator" style="left: 25%; bottom: -25px; position: absolute; transform: translateX(-50%)">{Math.round(min + (max - min) / 4)}</div>
                        <div class="ns-indicator" style="left: 50%; bottom: -25px; position: absolute; transform: translateX(-50%)">{Math.round(min + ((max - min) / 4) * 2)}</div>
                        <div class="ns-indicator" style="left: 75%; bottom: -25px; position: absolute; transform: translateX(-50%)">{Math.round(min + ((max - min) / 4) * 3)}</div>
                        <div class="ns-indicator" style="right: 0%; bottom: -25px; position: absolute; transform: translateX(50%)">{Math.round(max)}</div>
                    </div>
                    <div class="ns-slider-segments-lines">
                        <div class="ns-indicator-line" style="left: 0%;"></div>
                        <div class="ns-indicator-line" style="left: 25%;"></div>
                        <div class="ns-indicator-line" style="left: 50%;"></div>
                        <div class="ns-indicator-line" style="left: 75%;"></div>
                        <div class="ns-indicator-line" style="right: 0%;"></div>
                    </div>
                </div>
            </div>
        </li>
    );
}